/**
 * useRoles Hook - Fetches professional roles from Supabase
 */

import { useState, useEffect } from 'react';
import { getProfessionalRoles } from '../services/userService';

/**
 * Hook to fetch professional roles with translations
 * @param {string} lang - Language code ('it', 'en', etc.)
 * @returns {{roles: Array, loading: boolean, error: string|null, refetch: Function}}
 */
export const useRoles = (lang = 'it') => {
  const [roles, setRoles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchRoles = async () => {
    setLoading(true);
    setError(null);
    
    try {
      const data = await getProfessionalRoles(lang);
      setRoles(data);
    } catch (err) {
      console.error('useRoles error:', err);
      setError(err.message || 'Failed to load roles');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchRoles();
  }, [lang]);

  return {
    roles,
    loading,
    error,
    refetch: fetchRoles
  };
};

export default useRoles;
